import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loadedChat: false,
  home: null,
  project: null,
  contact: null,
  company: null,
  whatWeDo: null,
  legal: null,
  commonApp: null,
  categories: null,
  projectsSummaryList: null,
  projectDetail: null,
  projectsListForHome: null,
  reviewsListForHome: null,
  reviewsList: null,
  team: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
